/**
 * This is how we send messages back to the native app
 * The API only supports sending strings, so the caller should stringify
 * any the native app expects and it can parse it when it gets there.
 */
export const sendMessageToNativeApp = (msg: string) => {
  //@ts-ignore
  window?.webkit?.messageHandlers?.callbackHandler?.postMessage(msg)
}
